import { TimestampFormatProvider } from "@/shared/components/RobotoMarkdown/timeFormat";

import { AIChatProvider, useAIChat } from "./AIChatContext";
import { ChatFullscreenModal } from "./ChatFullscreenModal";
import styles from "./ChatSidebar.module.css";
import { ChatSidebarControls } from "./ChatSidebarControls";
import { ChatSidebarMainContent } from "./ChatSidebarMainContent";

interface ChatSidebarProps {
  onClose: () => void;
}

const ChatSidebarContent = ({ onClose }: ChatSidebarProps) => {
  const { isFullscreen } = useAIChat();

  return (
    <>
      <ChatFullscreenModal open={isFullscreen} onClose={onClose} />
      <div className={styles.container}>
        <ChatSidebarControls onClose={onClose} />
        <ChatSidebarMainContent />
      </div>
    </>
  );
};

export const ChatSidebar = ({ onClose }: ChatSidebarProps) => {
  return (
    <AIChatProvider>
      {/*
       * Static `storageKey` is intentional: the timestamp-format preference is
       * global across all chat sessions, not per-session. Switching chats keeps
       * the user's chosen format.
       */}
      <TimestampFormatProvider storageKey="roboto-ai-chat-time-format">
        <ChatSidebarContent onClose={onClose} />
      </TimestampFormatProvider>
    </AIChatProvider>
  );
};
